module.exports = __webpack_public_path__ + "img/sign.97b01fda.png";